import FilledButton from "../../../component/FilledButton";
import { Form } from "antd";
import { useEffect } from "react";

const SearchPop = ({ categoryData, setcategoryData, setModalOpen, filteredPosts, setSearch }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        form.resetFields();
    }, [filteredPosts])

    return (
        <div className="modal_body">
            <Form
                form={form}
                name="register"
                onFinish={(e) => { setcategoryData(e, form); setModalOpen(false) }}
                onReset={() => { setModalOpen(false) }}
                initialValues={categoryData}
                className="attached_courses-add_skill search_modal"
            >
                <h2>Search Free Classes</h2>
                <Form.Item name="title" className="form_group">
                    <input name="name" type="text" className="form_control" autoComplete='off' autoFocus />
                </Form.Item>
                <div className="form_group form_footer">
                    <FilledButton type="reset" className="btn btn_gray" value="Cancel" />
                    <FilledButton type="submit" className="btn btn_primary" value="Search" />
                </div>
            </Form>
        </div>
    )
};

export default SearchPop;